import * as React from 'react';

export const NotFound: React.FC = () => <div>404 Not found</div>;
